import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface CategorySectionProps {
  activeCategory: string | null;
  onCategoryChange: (slug: string | null) => void;
}

export default function CategorySection({ activeCategory, onCategoryChange }: CategorySectionProps) {
  return (
    <section className="py-12 bg-background-50" aria-labelledby="category-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 id="category-heading" className="font-heading text-2xl text-foreground-950">
            漫画分类
          </h2>
          {activeCategory && (
            <button
              onClick={() => onCategoryChange(null)}
              className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap flex items-center gap-1 cursor-pointer"
            >
              <i className="ri-refresh-line w-4 h-4 flex items-center justify-center"></i>
              查看全部
            </button>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onCategoryChange(activeCategory === cat.slug ? null : cat.slug)}
              className={`flex flex-col items-center gap-2 p-4 rounded-xl transition-all duration-300 cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white shadow-lg scale-105'
                  : 'bg-white hover:bg-primary-50 text-foreground-700 hover:text-primary-500'
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{cat.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}